import requestReducer from '../requestReducer';
import Order from '../../models/Order';
import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'


export interface OrderDetailState extends PaginatedApiState {
  orderLines?: Order[]
  isChacoClient?: boolean
}

const OrderDetail = (state: OrderDetailState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<OrderDetailState>('ORDER_DETAIL')(state, action)
  }
}

export default OrderDetail